import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import {
  PAYMENT_STATUS_OPTIONS,
  FULFILLMENT_STATUS_OPTIONS,
  EMAIL_STATUS_OPTIONS,
} from "./examUtils";

// Compact filters for the exam-purchases list.
const ExamPurchaseFilters = ({
  search,
  onSearchChange,
  onSearchSubmit,
  paymentStatus,
  onPaymentStatusChange,
  fulfillmentStatus,
  onFulfillmentStatusChange,
  emailStatus,
  onEmailStatusChange,
  startDate,
  onStartDateChange,
  endDate,
  onEndDateChange,
  sort,
  onSortChange,
  onResetFilters,
}) => {
  const selectClass = "form-select form-select-sm";
  const inputClass = "form-control form-control-sm";

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3 shadow-sm">
      <div className="flex flex-col gap-2">
        {/* Row 1: search + exam type */}
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <div className="flex min-h-9 w-full max-w-xs items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 text-slate-500 focus-within:border-slate-400 focus-within:bg-white">
            <FontAwesomeIcon
              icon={faSearch}
              size="sm"
              onClick={onSearchSubmit}
              style={{ cursor: "pointer" }}
            />
            <input
              type="text"
              className="w-full bg-transparent text-[13px] text-slate-700 outline-none placeholder:text-slate-400"
              placeholder="Search by customer name or email..."
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") onSearchSubmit();
              }}
            />
          </div>
        </div>

        {/* Row 2: status filters + dates */}
        <div className="flex flex-wrap items-center gap-2">
          <select
            className={selectClass}
            style={{ minWidth: "135px" }}
            value={paymentStatus}
            onChange={(e) => onPaymentStatusChange(e.target.value)}
          >
            <option value="">All Payments</option>
            {PAYMENT_STATUS_OPTIONS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>

          <select
            className={selectClass}
            style={{ minWidth: "150px" }}
            value={fulfillmentStatus}
            onChange={(e) => onFulfillmentStatusChange(e.target.value)}
          >
            <option value="">All Fulfillments</option>
            {FULFILLMENT_STATUS_OPTIONS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>

          <select
            className={selectClass}
            style={{ minWidth: "125px" }}
            value={emailStatus}
            onChange={(e) => onEmailStatusChange(e.target.value)}
          >
            <option value="">All Emails</option>
            {EMAIL_STATUS_OPTIONS.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>

          <div className="flex items-center gap-1.5">
            <input
              type="date"
              className={inputClass}
              style={{ width: "auto" }}
              value={startDate}
              onChange={(e) => onStartDateChange(e.target.value)}
              title="Start date"
            />
            <span className="text-slate-400">–</span>
            <input
              type="date"
              className={inputClass}
              style={{ width: "auto" }}
              value={endDate}
              onChange={(e) => onEndDateChange(e.target.value)}
              title="End date"
            />
          </div>
        </div>

        {/* Row 3: sort + reset */}
        <div className="flex items-center gap-2">
          <select
            className={selectClass}
            style={{ minWidth: "140px" }}
            value={sort}
            onChange={(e) => onSortChange(e.target.value)}
          >
            <option value="newest">Newest First</option>
            <option value="oldest">Oldest First</option>
            <option value="-amount">Amount (High-Low)</option>
            <option value="amount">Amount (Low-High)</option>
          </select>

          <button
            type="button"
            className="rounded-lg border border-slate-300 bg-white px-2.5 py-1 text-xs font-medium text-slate-700 hover:bg-slate-100"
            onClick={onResetFilters}
          >
            Reset Filters
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExamPurchaseFilters;
